import UserDashboard from '../components/UserDashboard';

function DashboardPage() {
  return <UserDashboard />;
}

export default DashboardPage;
